module.exports = __webpack_public_path__ + "static/media/nuclear-energy-permits.eefc1f65.svg";